import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPage } from '@/components/legal/legal-page'
import { LEGAL_UPDATED, privacySections } from '@/constants/legal'

const Privacy: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Privacy'
                description='What Updraft keeps about you, why we keep it, who else sees it and how to ask us to delete it.'
            />

            <LegalPage
                title='Privacy policy'
                intro='What we keep, why we keep it and how to make us forget it. No legalese where we could avoid it.'
                updated={LEGAL_UPDATED}
                sections={privacySections}
            />
        </Layout>
    )
}

export default Privacy
